// @core/api/endpoints/apikey/validate_api_key.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ValidateAPIKeyRequest,
  ValidateAPIKeyResponse,
} from '../../../types/apikey';

const BASE_PATH = '/apikey';

/**
 * Validate a p i key
 * Performs validate operation on a p i key.
 */
export async function ValidateAPIKey(
  data: ValidateAPIKeyRequest,
  options?: RequestOptions
): Promise<ValidateAPIKeyResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/validate_api_key`;
  const requestOptions = options;
  return client.post<ValidateAPIKeyResponse>(requestPath, data, requestOptions);
}
